import { useMemo } from "react";

import { DarkModeIcon, LightModeIcon } from "@moment/icons";

import { IconButton } from "../Button";
import { DropdownMenu } from "../DropdownMenu";
import { useTheme } from "../ThemeProvider";
import { useIsMounted } from "../hooks";
import { isRunningInIframe, sendPostMessage } from "../utils";

export function ThemeSwitcher() {
	const { resolvedTheme, theme: selectedTheme, setTheme, themes } = useTheme();

	// Avoid hydration mismatch: always render LightModeIcon on server and first client render.
	// After mount, switch to the actual theme icon.
	const isMounted = useIsMounted();

	// FIXME: Figure out why this is necessary.
	const uniqueThemes = useMemo(() => {
		return [...new Set(themes)];
	}, [themes]);

	const wrappedSetTheme = (theme: string) => {
		setTheme(theme);
		if (isRunningInIframe()) {
			sendPostMessage("setTheme", { theme });
		}
	};

	// Only show the actual theme icon after hydration is complete
	const showDarkIcon = isMounted && resolvedTheme === "dark";

	return (
		<DropdownMenu.Root>
			<DropdownMenu.Trigger asChild>
				<IconButton
					preset="quaternary"
					icon={showDarkIcon ? <DarkModeIcon /> : <LightModeIcon />}
					label="Theme"
				/>
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<DropdownMenu.Content>
					{uniqueThemes.map((theme) => (
						<DropdownMenu.CheckboxItem
							key={theme}
							checked={theme === selectedTheme}
							onSelect={() => wrappedSetTheme(theme)}
						>
							{theme}
						</DropdownMenu.CheckboxItem>
					))}
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
}
